import { PageTitle } from '@app/components/various/PageTitle';
import { clearFailedProducts, getFailedProducts, getOrderDetails } from '@app/ducks';
import { mapOrderProductsToGAItems, useGTM } from '@app/utils/analytics';
import { useEffectOnce } from '@app/utils/hooks';
import { isNull } from '@app/utils/is';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { OrderProductsContextProvider } from '../OrderProducts/OrderProductsContext';
import { OrderTopBar } from '../OrderTopBar';

import { OrderDetailsPageContent } from './OrderDetailsPageContent';

export const OrderDetailsPage = () => {
  const dispatch = useDispatch();
  const orderDetails = useSelector(getOrderDetails);
  const { t } = useTranslation(['selections']);
  const { trackGTMEvent } = useGTM();
  const failedProductsData = useSelector(getFailedProducts);
  const title = t('selections:selection_number', {
    orderNumber: orderDetails.order.orderNumber,
  });
  const pageTitle = `${title} - ${t('selections:my_selection')}`;

  useEffectOnce(() => {
    trackGTMEvent('view_cart', {
      ecommerce: {
        currency: orderDetails.currency.currency,
        items: mapOrderProductsToGAItems(orderDetails),
        value: orderDetails.order.totals.itemsTotalPriceAsNumber,
      },
    });
  });

  React.useEffect(() => {
    return () => {
      if (!isNull(failedProductsData)) {
        dispatch(clearFailedProducts());
      }
    };
  }, [failedProductsData, dispatch]);

  return (
    <>
      <PageTitle title={pageTitle}>
        <OrderTopBar isSelectionPage />
        <OrderProductsContextProvider orderDetails={orderDetails}>
          <OrderDetailsPageContent />
        </OrderProductsContextProvider>
      </PageTitle>
    </>
  );
};
